import { EstadoCuentaType } from "api/Types/EstadoCuenta"
import { useTranslation } from "react-i18next"
import { ESTADOS_PROPERTIES } from "../constants/BankAccountStatus"

export const BankAccountStatus = ({
  status,
}: {
  status?: EstadoCuentaType
}): JSX.Element => {
  const { t } = useTranslation()
  const { className, text } = ESTADOS_PROPERTIES(t)[status ?? "default"]

  return <div className={className}>{text}</div>
}
